import React from 'react'
import CustomerService2 from '../../images/customer-service2.png'
import CallBanner from '../../images/call_banner.png'

const style = {
  img: { height: '80px', width: '80px' },
  phoneText: { fontSize: '22px' },
  phoneLink: { height: '22px' },
  phoneImg: { width: '32px', height: '22px' }
}

const ContactDetails = ({ mountedInErrorPopup }) => {
  return (
    <>
      <div className='img_banner'>
        <span>Call Now!</span>
        <a href='tel:+1-213-225-9813'>
          <img
            src={CustomerService2}
            alt=''
            style={mountedInErrorPopup && style.img}
          />
        </a>
        <span>24x7x365</span>
      </div>
      <div
        className='sa-call-img-blk text-center'
        style={{ height: mountedInErrorPopup ? '22px' : '28px' }}
      >
        <div className='getcl-blk'>
          <span className='sa-phno-txt'>
            <a
              href='tel:+1-213-225-9813'
              className='visible-xs'
              style={mountedInErrorPopup && style.phoneLink}
            >
              <img
                className='get-phnimg'
                src={CallBanner}
                alt=''
                style={mountedInErrorPopup && style.phoneImg}
              />
              <span style={mountedInErrorPopup && style.phoneText}>
                1-213-225-9813
              </span>
            </a>
          </span>
        </div>
      </div>
    </>
  )
}

export default ContactDetails
